import React, { useState, useEffect } from 'react';
import MiniSpinner from "../General/MiniSpinner";
import { getUserTypes } from "../../actions/usuariosActions";
import { getSidebarItems } from "../../actions/sidebarActions";

export default function UserSidebarItems({ 
  tipoUsuario, 
  previousHiddenItems = [],
  updateHiddenItems
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [listAllIds, setListAllIds] = useState([]);
  const [hiddenItems, setHiddenItems] = useState(previousHiddenItems);
  const [isAllVisible, setIsAllVisible] = useState(previousHiddenItems?.length === 0);

  useEffect(() => {
    const userType = getUserTypes(tipoUsuario);
    const userItems = getSidebarItems(userType);
    setSidebarItems(userItems);

    const getItemsIds = (sidebarItems) => {
      let listIds = [];
      sidebarItems.map((item) => {
        listIds.push(item.id);
        if (item.childItems && item.childItems.length > 0) {
          item.childItems.map((childItem) => { listIds.push(childItem.id) });
        }
      });
      return listIds;
    };
    const itemsId = getItemsIds(userItems);
    setListAllIds(itemsId);

    setIsLoading(false);
  }, [tipoUsuario, previousHiddenItems]);

  useEffect(() => {
    setHiddenItems(previousHiddenItems);
  }, [previousHiddenItems]);

  useEffect(() => {
    setIsAllVisible(hiddenItems?.length === 0);
    updateHiddenItems(hiddenItems);
  }, [hiddenItems]);

  const handleToggleAllCheckbox = (e) => {
    e.preventDefault();
    setHiddenItems(isAllVisible ? listAllIds : []);
  };

  const handleToggleCheckboxs = (id, isHidden, parentId) => {
    setHiddenItems(prevHiddenItems => {
      let updatedHiddenItems = toggleHiddenItem(id, isHidden, prevHiddenItems);
      const parentItem = sidebarItems.find(item => item.id === (parentId ?? id));

      if (parentItem?.childItems) {
        const childIds = parentItem.childItems.map(childItem => childItem.id);
        const isParentClicked = parentId === undefined;

        if (isParentClicked) {
          childIds.forEach(childId => {
            updatedHiddenItems = toggleHiddenItem(childId, isHidden, updatedHiddenItems);
          });
        } else {
          const isHiddenEveryChild = childIds.every(childId => updatedHiddenItems.includes(childId));
          updatedHiddenItems = toggleHiddenItem(parentId, !isHiddenEveryChild, updatedHiddenItems);
        }
      }

      return updatedHiddenItems;
    })
  };

  const toggleHiddenItem = (itemId, isHidden, currentHiddenItems) => {
    return isHidden ? currentHiddenItems.filter(id => id !== itemId) : [...currentHiddenItems, itemId];
  };

  const renderItem = (item, parentId) => {
    const { id, icon, label, childItems } = item;
    const isHidden = hiddenItems?.includes(id);
    const isChild = parentId !== undefined;

    return (
      <div className={`col-12 ${isChild ? 'ms-3' : ''}`} key={id}>
        <div className="hover-background-color">

          <label htmlFor={`input-${id}`}>
            {isChild && IconSubDirectory()}
            {IconEye(isHidden)}
          </label>

          <input
            type="checkbox"
            id={`input-${id}`}
            checked={!isHidden}
            onChange={() => handleToggleCheckboxs(id, isHidden, parentId)}
            className="custom-control-input big-checkbox me-1"
          />

          <label htmlFor={`input-${id}`}>
            <i className={icon + " prevent-select"} /> {label}
          </label>

        </div>
        {childItems && childItems.map((child => renderItem(child, id)))}
      </div>
    )
  }


  return (
    <div className="row">

      <div className="col-12 col-md-6">
        <label className="control-label">Secciones visibles</label>
      </div>

      <div className="col-12">
        <button
          className="btn btn-sm btn-light"
          onClick={(e) => handleToggleAllCheckbox(e)}
        >
          {IconEye(isAllVisible)}
          {isAllVisible ? "Ocultar todo" : "Mostrar todo"}
        </button>
      </div>

      <div className="col-12 col-sm-10 m-4">
        {isLoading ? <MiniSpinner /> :
          <div className="row">
            {sidebarItems.map((item) => { return renderItem(item) })}
          </div>
        }
      </div>

    </div>
  );
}

const IconEye = (isHidden) => <i className={`me-1 mdi mdi-eye${isHidden ? "-off" : ""}`} />;
const IconSubDirectory = () => <i className="mdi mdi-subdirectory-arrow-right color-gris-megatone" />;